import axios from 'axios'

// const webUrl = 'http://www.choicelink.cn:8888' // 阿里云下载等IP
const webUrl = 'http://medical.chinapsp.cn:8888' // 阿里云下载等IP

let fileUtil = {
  async downloadInit(userId, fileType) {
    let rep = await axios.get(`${webUrl}/AliOSS/GetSign?dir=test3/`)
    let obj = rep.data
    let extradata = {
      'key': obj['dir'], // 未加后缀
      'policy': obj['policy'],
      'OSSAccessKeyId': obj['accessid'],
      'success_action_status': '200', //让服务端返回200,不然，默认会返回204calculate_object_name(filename)
      'callback': obj['callback'],
      'signature': obj['signature'],
      'x:objectid': "",
      'x:userid': userId, // 用户id
      'x:filetype': fileType, // 10报名 11付费
      'x:objectidtype': '',
      'x:displayname': "", // 文件名称
    }
    let action = obj['host']
    return {
      extradata, // 上传附带基本参数
      action, // 上传地址
    }
  },
  // 随机后缀名
  random_string(len = 32) {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ+abcdefghijklmnopqrstuvwxyz-012345678*';
    let maxPos = chars.length;
    let pwd = '';
    for (var i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },
  // 获取后缀
  get_suffix(filename) {
    let pos = filename.lastIndexOf('.')
    let suffix = ''
    if (pos != -1) {
      suffix = filename.substring(pos)
    }
    return suffix;
  },
  async downLoad(fileId) {
    let rep = await axios.get(`${webUrl}/AliOSS/GetDownUrl`, {
      params: {
        id: fileId
      }
    })
    return rep.data.url
  }
}

export { fileUtil }
